<template>
  <div
    v-if="!loader"
    class="row"
  >
    <div class="col-20 std-wrapper">
      <filters @change="(result) => filters = result" />
    </div>
    <div class="col-20 std-wrapper">
      <info-bar-influencer v-if="this.$store.state.user.profile.type === 'influencer'" />
      <info-bar-advertiser v-else />
    </div>

    <div class="col-20 mt-4 mb-2 nh-list">
      <list-for-advertisers
        v-if="!listIsEmpty && $store.state.user.profile.type === 'advertiser'"
        class=""
        :list="list"
      />
      <list-for-influencers
        v-if="!listIsEmpty && $store.state.user.profile.type === 'influencer'"
        class=""
        :list="list"
      />
    </div>

    <div
      v-if="listIsEmpty"
      class="mt-5 mb-5 col-20 text-center font-weight-bold"
    >
      {{ $t('view-Payments.empty-list') }}
    </div>
  </div>
</template>

<script>
import Filters from './Filters'
import InfoBarInfluencer from './InfoBarInfluencer'
import InfoBarAdvertiser from './InfoBarAdvertiser'
import ListForAdvertisers from './ListForAdvertisers'
import ListForInfluencers from './ListForInfluencers'
import '../../assets/scss/nh-list.scss'

export default {
  components: {
    filters: Filters,
    'info-bar-influencer': InfoBarInfluencer,
    'info-bar-advertiser': InfoBarAdvertiser,
    'list-for-advertisers': ListForAdvertisers,
    'list-for-influencers': ListForInfluencers
  },
  props: {
    loader: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      filters: {
        status: 'all'
      }
    }
  },
  computed: {
    listIsEmpty () {
      return this.$store.state.payments.items.length === 0
    },
    list () {
      let list = this.$store.state.payments.items

      if (this.filters.status !== 'all') {
        list = list.filter(i => i.status === this.filters.status)
      }

      if (this.filters.id) {
        list = list.filter(i => i.id === parseInt(this.filters.id.replace('#', '')))
      }

      if (this.filters.date) {
        const filterDate = new Date(this.filters.date)
        filterDate.setHours(0, 0, 0, 0)

        list = list.filter(i => {
          const date = new Date(i.created_at)
          date.setHours(0, 0, 0, 0)

          return date.valueOf() === filterDate.valueOf()
        })
      }
      if (this.filters.campaign_name) {
        const regex = new RegExp(`${this.filters.campaign_name}`, 'i')
        list = list.filter(i => i.campaign && true).filter(i => i.campaign.name.match(regex))
      }
      if (this.filters.advertiser_name) {
        const regex = new RegExp(`${this.filters.advertiser_name}`, 'i')
        list = list.filter(i => i.payer && i.payer.type === 'advertiser').filter(i => i.payer.name.match(regex))
      }
      if (this.filters.influencer_name) {
        const regex = new RegExp(`${this.filters.influencer_name}`, 'i')
        list = list.filter(i => i.taker && i.taker.type === 'influencer').filter(i => {
          const name = `${i.taker.influencer.fullName} ${i.taker.name}`
          return name.match(regex)
        })
      }

      return list
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .info-box {
    .label, .value {
      width: 100%;
      display: inline-block;
      text-align: center;
    }
    .value {
      font-size: 1.25rem;
      font-weight: 600;
    }
    .sep {
      border-right: 2px solid $nh-gray;
    }
    .contract-data-info {
      font-size: 0.75rem;
    }
  }
</style>
